import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Environment } from '../../Environment';
import { SharedDataService } from './shared-data.service';



@NgModule({
  imports: [
    CommonModule
  ]
})
export class SharedDataModule {
  constructor(@Optional() @SkipSelf() parentModule?: SharedDataModule) {
    if (parentModule) {
      throw new Error(
        'SharedDataModule is already loaded. Import it in the AppModule only');
    }
  }

  static forRoot(pafEnvironment: Environment): ModuleWithProviders<SharedDataModule> {
    return {
      ngModule: SharedDataModule,
      providers: [
        SharedDataService,
        {provide: 'env', useValue: pafEnvironment }
      ]
    };
  }
 }
